<script setup lang="ts">
import type { DashboardBadges } from '@/constants/tabs';

import DashboardBadge from '@/components/badges/DashboardBadge.vue';
import { useTabsStore } from '@/stores/useTabsStore';
import { dashboardTabs } from '@/constants/tabs';

import tabsStyles from '@/styles/tabs.module.scss';

export interface Props {
  badges?: DashboardBadges;
}
const props = withDefaults(defineProps<Props>(), {
  badges: () => ({}),
});

const tabsStore = useTabsStore();
</script>

<template>
  <div :class="[$style.smartDashboardTabs, tabsStyles.tabsWrapper]">
    <v-tabs v-model="tabsStore.tabs.dashboard" :class="tabsStyles.tabs">
      <v-tab
        v-for="(tabValue, tabKey, tabIndex) in dashboardTabs"
        :key="tabKey"
        :value="tabKey"
        :ripple="false"
        :class="tabsStyles.tab"
        variant="plain"
      >
        {{ tabValue }}
        <DashboardBadge
          :class="$style.badge"
          :type="tabKey"
          :content="props.badges[tabKey]"
        />
      </v-tab>
    </v-tabs>
  </div>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.smartDashboardTabs {
  display: inline-block;
}
  .badge {
    margin-left: 3px;
  }
</style>
